export default {
    tel_number: {
        max: 11,
        min: 10
    },
}
